<template>
  <div class="flex min-h-screen flex-col bg-base-200">
    <m-dot-loader v-if="loading" :layout="['center', 'grow']" />
    <template v-else>
      <header v-if="$slots.header">
        <slot name="header" />
      </header>

      <slot></slot>
      <footer v-if="$slots.footer">
        <slot name="footer"></slot>
      </footer>
    </template>
  </div>
</template>

<script lang="ts" setup>
  /**
   * This component is use to create layout components
   */
  import MDotLoader from '@core/components/MDotLoader/MDotLoader.vue';

  defineProps({
    loading: {
      type: Boolean,
      default: false,
      required: false,
    },
  });
</script>
